const journalMetals = {
  platinum: 'platinum',
  palladium: 'palladium',
  rhodium: 'rhodium',
};

const allJournalMetals = Object.values(journalMetals);

export { journalMetals, allJournalMetals };
